<template>
  <div class="adjust-price-container" v-show="orderInfo.orderNo">
    <div class="order-status_bar c:col-center">
      <div>{{ orderInfo.adjustStatus | filterAudit }}</div>
      <div class="reject-reson" v-show="orderInfo.adjustStatus === 2">
        驳回原因：{{ adjustVo.rejectRemark }}
      </div>
    </div>
    <div class="adjust-conut-container c:col-start-center">
      <div class="orgin-price">
        原价：¥ {{ adjustVo.originAmount | filterPrice }}
      </div>
      <div class="adjust-price">
        调价后：¥ {{ adjustVo.amount | filterPrice }}
      </div>
      <div class="adjust-price-remark">
        调价原因：{{ adjustVo.innerRemark }}
      </div>
    </div>
    <div class="adjust-price-main-container">
      <div class="order-list">
        <OrderItemCard
          :index="index"
          :data="item"
          v-for="(item, index) in orderInfo.orderItems"
          :key="index"
          :canModifyPrice="true"
        />
      </div>
      <div class="total-amount c:row-between-center">
        <span>订单金额</span>
        <span class="price-number"
          >¥ {{ adjustVo.orderAmount | filterPrice }}</span
        >
      </div>
    </div>
    <div
      class="page-bottom-btn-container c:row-between-center"
      v-show="isStoreManagerAccount && orderInfo.adjustStatus === 0"
    >
      <van-button class="w100" @click.native="onRejectAdjust">驳回 </van-button>

      <van-button class="w100" type="primary" @click.native="onApproveAdjust"
        >批准
      </van-button>
    </div>
    <div
      class="page-bottom-btn-container c:row-between-center"
      v-show="isSalerAccount && orderInfo.adjustStatus !== 0"
    >
      <van-button
        v-if="orderInfo.adjustStatus === 2 && orderInfo.status == 0"
        class="w100"
        @click.native="onReQuest"
        >重新申请
      </van-button>
      <van-button class="w100" type="primary" @click.native="onToDetail"
        >查看订单详情
      </van-button>
    </div>
    <AdjustPricePopup
      :show.sync="showAdjustPopup"
      :data="modifyData"
      @submit="onReQuestSubmit"
      :default-remark="changeRemark"
      :default-price="modifyPrice"
    />
    <van-dialog
      v-model="showRejectPopup"
      title="驳回理由"
      :show-confirm-button="false"
    >
      <div class="reject-text-container">
        <textarea
          placeholder="请输入驳回理由"
          rows="4"
          class="w100 reject-text"
          v-model="rejectRemark"
          maxlength="200"
        ></textarea>
      </div>
      <div class="reject-btns c:row-between-center">
        <van-button class="w100" @click.native="() => (showRejectPopup = false)"
          >取消
        </van-button>
        <van-button
          class="w100"
          type="primary"
          :disabled="!rejectRemark"
          @click="onRejectAdjustSubmit"
          >确定
        </van-button>
      </div>
    </van-dialog>
    <CConfirm ref="refCConfirm" />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import {
    getOrderDetailInWorkApi,
    auditAdjustPriceApi,
    reApplyAdjustPriceApi
  } from '@/api'
  import AdjustPricePopup from '@/components/common/AdjustPricePopup.vue'
  import OrderItemCard from '@/components/order/widgets/OrderItemCard.vue'
  import CConfirm from '@/components/common/CConfirm.vue'
  import { useDefaultWxWorkConfig } from '@/utils/wechat'

  // 路由跳转到此页面需要携带orderNo（必填）, id（必填）
  export default {
    data() {
      return {
        orderInfo: {},
        adjustVo: {},
        showAdjustPopup: false,
        modifyData: { data: {} },
        changeRemark: '',
        modifyPrice: '',
        showRejectPopup: false,
        rejectRemark: ''
      }
    },
    components: {
      OrderItemCard,
      AdjustPricePopup,
      CConfirm
    },
    computed: {
      ...mapGetters(['isStoreManagerAccount', 'isSalerAccount'])
    },
    methods: {
      onToDetail() {
        this.$router.replace(`/sa/order?orderNo=${this.orderInfo.orderNo}`)
      },
      onReQuest() {
        this.showAdjustPopup = true
        console.log('modifyData', this.orderInfo.orderItems)
        this.modifyData = {
          data: {
            ...this.orderInfo.orderItems[0]
          }
        }

        this.modifyPrice = String(this.orderInfo.orderItems[0].price)
        this.changeRemark = ''
      },
      onReQuestSubmit({ modifyPrice, changeRemark }) {
        if (modifyPrice == '') {
          this.$toast('调整后价格不可为空')
          return false
        }
        if (
          parseFloat(modifyPrice) == parseFloat(this.adjustVo.originalPrice)
        ) {
          this.$toast('调整后价格应不等同于原价')
          return false
        }
        this.$toast.loading({
          message: '加载中',
          forbidClick: true
        })
        reApplyAdjustPriceApi({
          orderItemId: this.$route.query.id,
          price: modifyPrice,
          innerRemark: changeRemark
        })
          .then(() => {
            this.$toast('重新发起成功')
            this.showAdjustPopup = false
            this.getOrderInfo()
          })
          .finally(() => {
            this.$toast.clear()
          })
      },
      onApproveAdjust() {
        this.$refs.refCConfirm
          .show('确认批准调价?')
          .then(() => {
            this.$toast.loading({
              message: '加载中',
              forbidClick: true
            })
            auditAdjustPriceApi({
              orderAdjustPriceId: this.adjustVo.id,
              status: 1
            })
              .then(() => {
                this.getOrderInfo()
              })
              .finally(() => {
                this.$toast.clear()
              })
          })
          .catch(() => {})
      },
      onRejectAdjust() {
        this.showRejectPopup = true
        this.rejectRemark = ''
      },
      onRejectAdjustSubmit() {
        this.$toast.loading({
          message: '加载中',
          forbidClick: true
        })
        auditAdjustPriceApi({
          orderAdjustPriceId: this.adjustVo.id,
          status: 2,
          rejectRemark: this.rejectRemark
        })
          .then(() => {
            this.showRejectPopup = false
            this.getOrderInfo()
          })
          .finally(() => {
            this.$toast.clear()
          })
      },
      getOrderInfo() {
        const orderItemId = this.$route.query.id
        getOrderDetailInWorkApi(this.$route.query.orderNo).then(data => {
          const adjustVo = data.adjustPriceVos.find(item => {
            return item.orderItemId == orderItemId
          })
          const currentItem = data.orderItems.find(
            item => item.id == orderItemId
          )
          if (!adjustVo || !currentItem) {
            this.$toast('调价信息不存在')
            return
          }
          this.orderInfo = {
            ...data,
            isBaseOrder: data.type === 1,
            adjustStatus: adjustVo?.status,
            orderItems: [
              {
                ...currentItem,
                adjustPriceInnerRemark: adjustVo?.innerRemark
              }
            ]
          }
          this.adjustVo = {
            ...adjustVo,
            amount:
              adjustVo.status == 2
                ? adjustVo.price * adjustVo.qty
                : currentItem.adjustedPrice * adjustVo.qty,
            originAmount: currentItem.originalPrice * adjustVo.qty,
            orderAmount:
              adjustVo.status != 1
                ? currentItem.price * adjustVo.qty
                : adjustVo.price * adjustVo.qty
          }
        })
      }
    },
    mounted() {
      useDefaultWxWorkConfig()
      if (this.$route.query.orderNo && this.$route.query.id) {
        this.getOrderInfo()
      }
    }
  }
</script>
<style lang="less" scoped>
  .adjust-price-container {
    height: 100%;
    position: relative;
    padding-bottom: 96/20rem;
    .page-bottom-btn-container {
      position: fixed;
      width: 100%;
      height: 96/20rem;
      padding: 8/20rem 1rem 0;
      gap: 12/20rem;
      left: 0;
      bottom: 0;
    }
  }
  .adjust-price-main-container {
    padding: 0 1rem;
  }
  .order-status_bar {
    height: 60/20rem;
    background: #f7f7f7;
    font-size: 16px;
    color: #000;
    text-align: center;
    .reject-reson {
      font-size: 11px;
      color: #ed7867;
      width: 100%;
      text-align: center;
      bottom: 11/20rem;
      line-height: 11px;
      height: 11px;
      margin-top: 4/20rem;
    }
  }
  .total-amount {
    padding: 14/20rem 0;
    font-size: 14px;
    border-bottom: 1px solid #e4e4e4;
    .price-number {
      font-size: 15px;
      font-weight: 500;
    }
  }
  .adjust-conut-container {
    padding: 14/20rem 0;
    border-bottom: 1px solid #e4e4e4;
    .orgin-price {
      font-size: 13px;
      font-weight: 500;
      color: #5e5e5e;
      line-height: 18px;
    }
    .adjust-price {
      font-size: 14px;
      color: #000000;
      line-height: 20px;
      margin: 6/20rem 0;
    }
    .adjust-price-remark {
      font-size: 11px;
      color: #7d7d7d;
      line-height: 15px;
      padding: 0 1rem;
      text-align: center;
      word-break: break-all;
    }
  }

  .reject-text-container {
    padding: 1rem 0;
    .reject-text {
      padding: 12/20rem 10/20rem;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .reject-btns {
    gap: 12/20rem;
  }
</style>
